import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";
const GradingIcon = (props) => (
    <Svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <G clip-path="url(#clip0_7657_2734)">
            <Path d="M5.33398 9.33333H26.6673V12H5.33398V9.33333ZM5.33398 17.3333H26.6673V14.6667H5.33398V17.3333ZM5.33398 22.6667H14.6673V20H5.33398V22.6667ZM5.33398 28H14.6673V25.3333H5.33398V28ZM20.5473 24.2267L18.6673 22.3333L16.7873 24.2133L20.5473 28L26.6673 21.8933L24.774 20L20.5473 24.2267ZM5.33398 4V6.66667H26.6673V4H5.33398Z" fill="#323232" />
        </G>
        <Defs>
            <ClipPath id="clip0_7657_2734">
                <Rect width="32" height="32" fill="white" />
            </ClipPath>
        </Defs>
    </Svg>
);
export default GradingIcon;
